export enum MenuItemType {
  Article = 1,
  Component = 2,
  ExternalLink = 3
}
